"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockRemoveConfirmOption = void 0;
var BlockRemoveConfirmOption;
(function (BlockRemoveConfirmOption) {
    BlockRemoveConfirmOption["NoConfirm"] = "NoConfirm";
    BlockRemoveConfirmOption["Always"] = "Always";
    BlockRemoveConfirmOption["IfHasPublishedEnding"] = "IfHasPublishedEnding";
})(BlockRemoveConfirmOption = exports.BlockRemoveConfirmOption || (exports.BlockRemoveConfirmOption = {}));
